import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import Button from '../elements/Button';
import FooterSocial from '../layout/partials/FooterSocial';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

class HeroSplit extends React.Component {

  componentDidMount() {
    // this is only to handle inline style on window resize
    window.onresize = function () {
      this.forceUpdate();
    }.bind(this);
  }

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'hero section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'hero-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const splitClasses = classNames(
      'split-wrap',
      invertMobile && 'invert-mobile',
      invertDesktop && 'invert-desktop',
      alignTop && 'align-top'
    );

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <div className={splitClasses}>
              <div className="split-item" style={inlineStyle()}>
                <div className="hero-content split-item-content center-content-mobile">
                  <h1 className="mt-0 mb-16 reveal-from-top" data-reveal-delay="150">
                    {/* Libeccio */}
                  </h1>
                  <p className='mt-0 mb-0 reveal-from-top slogan-tip' data-reveal-delay="300">The next-gen</p>
                  <p className="mt-0 mb-24 reveal-from-top slogan" data-reveal-delay="300">
                    <b>Gaming Platform Solutions</b>
                  </p>
                  <div className="reveal-from-top join-whitelist" data-reveal-delay="450">
                    <Button tag="a" color="primary" href="mailto:support@libecc.io" wideMobile>
                      Contact Us
                    </Button>
                  </div>
                  <div className="reveal-from-top" data-reveal-delay="600" style={leftStyle}>
                   <FooterSocial />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

// inline style
const inlineCss = {
  alignItems: 'flex-start',
  minHeight: '300px'
}

const inlineStyle = function () {
  if (window.innerWidth > 641) {
    return inlineCss;
  }
};

const leftStyle = {
  justifyContent: 'left',
  marginTop: '5%',
  width: '150px',
}

HeroSplit.propTypes = propTypes;
HeroSplit.defaultProps = defaultProps;

export default HeroSplit;